import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeStyle'
})
export class SafeStylePipe implements PipeTransform {

  constructor(
    protected sanitizer: DomSanitizer
  ) {}

  transform(value: any, args?: any): any {
    return this.sanitizer.bypassSecurityTrustStyle(value);
  }

}
